// Estonian
export default {
  newVersionAvailable: 'Saadaval on uus versioon',
  versionInfo: '{appName} uus versioon on saadaval. Versioonile {version} uuendamiseks laadige leht uuesti.',
  reload: 'Laadi uuesti',
  later: 'Hiljem',
  intl_addr_country: 'Riik',
  intl_addr_address1: 'Aadress',
  intl_addr_address2: 'Aadress 2',
  intl_addr_address3: 'Aadress 3',
  intl_addr_address4: 'Aadress 4',
  intl_addr_city: 'Linn',
  intl_addr_state: 'Maakond',
  intl_addr_zipCode: 'Sihtnumber',
  intl_addr_longitude: 'Pikkuskraad',
  intl_addr_latitude: 'Laiuskraad',
  intl_addr_department: 'Osakond',
  intl_addr_suburb: 'Eeslinn',
  intl_addr_postalCode: 'Sihtnumber',
  intl_addr_province: 'Provints',
  intl_addr_neighborhood: 'Naabruskond',
};
